module.exports = __webpack_public_path__ + "img/00051.404469f4.webp";